import { ComboBoxDropDownItem } from "@/Common/Components/Inputs/Combobox";
import { GenderIdentity } from "@/Common/Models/Individuals/Enums/GenderIdentity";
import { PreferredPronouns } from "@/Common/Models/Individuals/Enums/PreferredPronouns";
import { EnumHelper } from "./EnumHelper";

class IndividualIdentityHelper {
    /**
     * Get available preferred pronouns
     * @returns {ComboBoxDropDownItem[]}
     */
    public static getAvailablePreferredPronouns(): ComboBoxDropDownItem[] {
        return this.getAllPreferredPronounsAsComboBox()?.distinctByProperty(p => p.DisplayName);
    }

    /**
     * Get available preferred pronouns
     * @returns {JSX.Element[]}
     */
    public static getAllPreferredPronounsAsHtmlOption(): JSX.Element[] {
        return EnumHelper.getNames(PreferredPronouns).map(pronoun => (
            <option key={pronoun} value={pronoun}>{EnumHelper.getValue(PreferredPronouns, pronoun) === PreferredPronouns.Unknown ? "" : cacheStore.GetString(`Enums_PreferredPronouns_${pronoun}`)}</option>
        ));
    }

    /**
     * Get available gender identities
     * @returns {ComboBoxDropDownItem[]}
     */
    public static getAllGenderIdentitiesAsComboBox(): ComboBoxDropDownItem[] {
        return Object.values(GenderIdentity)
            .filter(g => isNaN(Number(g)))
            .map((g: GenderIdentity, index) => IndividualIdentityHelper.genderIdentityToComboboxItem(g, index));
    }

    /**
     * Get available gender identities
     * @returns {JSX.Element[]}
     */
    public static getAllGenderIdentitiesAsHtmlOption(): JSX.Element[] {
        return EnumHelper.getNames(GenderIdentity).map(gender => (
            <option key={gender} value={gender}>{EnumHelper.getValue(GenderIdentity, gender) === GenderIdentity.Unknown ? "" : cacheStore.GetString(`Enums_GenderIdentity_${gender}`)}</option>
        ));
    }

    private static getAllPreferredPronounsAsComboBox(): ComboBoxDropDownItem[] {
        return Object.values(PreferredPronouns)
            .filter(g => isNaN(Number(g)))
            .map((g: PreferredPronouns, index) => this.preferredPronounsToComboboxItem(g, index));
    }

    private static preferredPronounsToComboboxItem(x: PreferredPronouns, index: number): ComboBoxDropDownItem {
        return new ComboBoxDropDownItem(
            PreferredPronouns[x],
            EnumHelper.getValue(PreferredPronouns, x) === PreferredPronouns.Unknown
                ? ""
                : cacheStore.GetString(`Enums_PreferredPronouns_${x.toString()}`),
            index
        );
    }

    private static genderIdentityToComboboxItem(x: GenderIdentity, index: number): ComboBoxDropDownItem {
        return new ComboBoxDropDownItem(
            GenderIdentity[x],
            EnumHelper.getValue(GenderIdentity, x) === GenderIdentity.Unknown
                ? ""
                : cacheStore.GetString(`Enums_GenderIdentity_${x.toString()}`),
            index
        );
    }
}

export { IndividualIdentityHelper };
